import React from 'react';
import { stylesLayout } from "../InputLayout.styles";
import { InputLayoutAsideIcon } from "../InputLayoutAsideIcon";
import { InputLayoutAsideText } from "../InputLayoutAsideText";
export var InputLayoutAside = function InputLayoutAside(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      side = _ref.side;
  var asideClassName = stylesLayout.aside();

  var _icon = /*#__PURE__*/React.createElement(InputLayoutAsideIcon, {
    key: "icon",
    icon: icon,
    side: side
  });

  var _text = /*#__PURE__*/React.createElement(InputLayoutAsideText, {
    key: "text",
    text: text
  });

  var child = side === 'left' ? [_icon, _text] : [_text, _icon];
  return /*#__PURE__*/React.createElement("span", {
    className: asideClassName
  }, child);
};